<template>
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form :inline="true" class="demo-form-inline">
          <div class="cg">
            <el-form-item label="用户名称：">
              <el-input
                v-model="listQuery.username"
                style="width: 200px"
                placeholder="请输入用户名称"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="角色下拉：">
              <el-select placeholder="请选择老师" v-model="input1" style="width: 100%" clearable filterable>
                <el-option v-for="item in optionList1" :key="item.poId" :value="item.poId" :label="item.poName"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item style="margin-left: 50px;">
              <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
            </el-form-item>
          </div>
        </el-form>
        <el-table
          :header-cell-style="{
            height: '40px',
            fontSize: '18px',
            color: 'black',
            fontweight: 400,
            background: '#fafafa'
          }"
          :header-row-style="{ text: 'center' }"
          v-loading="listLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          :data="tableData"
          border
          style="width: 100%;margin-top: 50px;"
          :highlight-current-row="true"
        >
          <el-table-column
            prop="adminNo"
            label="管理员编号"
            align="left"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="realname"
            label="真实姓名"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="创建时间">
          </el-table-column>
          <el-table-column prop="updateTime" align="center" label="修改时间">
          </el-table-column>
          <el-table-column label="操作" width="180px" header-align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" @click="updateUser(scope.row)">编辑</el-button>
              <el-button type="text" icon="el-icon-delete"  :disabled="isUser"  @click="updateUsers(scope.row)">删除</el-button>


<!--              <el-button type="text" icon="el-icon-delete">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <user-set-role ref="userSetRole"></user-set-role>
        <!--         分页 -->
        <el-pagination
          class="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.page"
          :page-size="listQuery.limit"
          layout="prev, pager, next,sizes, jumper"
          :total="listQuery.total"
        >
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import UserSetRole from "./UserSetRole.vue";

export default {
  components: { UserSetRole },
  data() {
    return {
      listQuery: {
        username: "",
        limit: 10, //每页多少条
        page: 1, //当前显示页码
        total: 0 // 总条数
      },
      listLoading: false, //加载样式
      tableData: [],
      optionList1:[],
      input1: "",

      isUser: true,

    };
  },
  created() {
    this.listData();
  },
  mounted() {

    this.isUser = window.sessionStorage.getItem('isUser') == 'true' ? true : false

    const data = {
        po_id: '0',
        poName: this.listQuery.roleName
      }
      axios
        .post(
          `${apiBaseUrl}/admin/postlist`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          this.optionList1 = response.data.data.list;
        })
        .catch(error => {
          console.log(error);
        });


  },
  methods: {
    //查询所有用户
    listData() {
      this.listLoading = true;
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        realname: this.listQuery.username,
        poId: this.input1
      };
      axios
        // .post(`${apiBaseUrl}/admin/userlist`, this.listQuery)
        .post(`${apiBaseUrl}/admin/userlist`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {

          if (response.data.code === 200) {
            this.$message.success(response.data.message);
            this.tableData = response.data.data.list;
            this.listQuery.total = response.data.data.count;
          } else {
            this.$message.error(response.data.message);
            this.tableData = []
            this.listQuery.total = 0
          }

        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //分页
    handleSizeChange(pageSize) {
      this.listQuery.limit = pageSize;
        this.listData();
    },
    // 进入某一页
    handleCurrentChange(newPage) {
      this.listQuery.page = newPage;
      this.listData();
    },
    //查询按钮
    handleSearch() {
      this.listQuery.page = 1
      this.listData();
    },
    //编辑按钮
    updateUser(user) {
      this.$nextTick(() => {
        this.$refs.userSetRole.showUser(user);
      });
    },

    updateUsers(row){
      this.$confirm('确定要删除吗?, 是否继续?', '提示', {  confirmButtonText: '确定', cancelButtonText: '取消',  type: 'warning' }).then(() => {
          axios.post(`${apiBaseUrl}/admin/delUser/${row.id}`, {}, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
            if (res.data.code === 200) {
              this.$message({ message:res.data.message, type: "success" })
              this.listData()
            } else {
              this.$message.error(res.data.message)
            }
          }).catch((err) => {
            this.$message.error(err)
          })
      })
    },



  }
};
</script>
<style scoped>
.demo-form-inline {
  height: 35px;
  display: flex;
}

.cg {
  margin-top: 20px;
}
.page {
  margin-top: 20px;
  text-align: right;
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/UserManagement.vue